import devModeConsole from '../../helpers/devModeConsole';

const defaultSizeMapping = {
  regular: 'm',
  multiline: 'xl'
};
const consoleMessages = {
  multilineSizeNotRecommended: `size is not recommended for multiline TextField. Make sure this is the requirement from your designer.`
};

const multilineRecommendedSizes = ['m', 'l', 'xl', 'fullWidth'];

export const getTextFieldSize = (incomingSize, multiline) => {
  if (!incomingSize) {
    return multiline
      ? defaultSizeMapping.multiline
      : defaultSizeMapping.regular;
  }

  if (multiline) {
    const isSizeRecommended = multilineRecommendedSizes.includes(incomingSize);
    const warnMessage = `'${incomingSize}' ${consoleMessages.multilineSizeNotRecommended}`;
    devModeConsole({
      promptWhen: !isSizeRecommended,
      message: warnMessage
    });
  }

  return incomingSize;
};
